export type AppLocale = 'es' | 'en'

export const APP_LOCALE_STORAGE_KEY = 'wrlens:app-locale'
export const DEFAULT_APP_LOCALE: AppLocale = 'es'

export const APP_INTL_LOCALE: Record<AppLocale, string> = {
  es: 'es-ES',
  en: 'en-US',
}

export type TranslateVars = Record<string, string | number>

export function isAppLocale(value: unknown): value is AppLocale {
  return value === 'es' || value === 'en'
}

export function readStoredAppLocale(): AppLocale {
  if (typeof window === 'undefined') return DEFAULT_APP_LOCALE
  try {
    const raw = window.localStorage.getItem(APP_LOCALE_STORAGE_KEY)
    return isAppLocale(raw) ? raw : DEFAULT_APP_LOCALE
  } catch {
    return DEFAULT_APP_LOCALE
  }
}

export function writeStoredAppLocale(locale: AppLocale): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(APP_LOCALE_STORAGE_KEY, locale)
  } catch {
    // noop
  }
}
